import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "input-icon--left" }
const _hoisted_3 = { class: "col-main" }
const _hoisted_4 = ["for", "innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "input-icon--right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-field", {
      'invalid': _ctx.hasError,
      'readonly': _ctx.readonly,
      'valid': !_ctx.showLoader && !_ctx.hasError && _ctx.showValidCheck,
      'loading': _ctx.showLoader,
      'icon-right': _ctx.iconRight,
      'icon-left': _ctx.iconLeft,
      'borderless': _ctx.borderless,
      'rounded': _ctx.rounded,
      'filled': _ctx.filled,
      'focused': _ctx.focused,
      'label-hidden': _ctx.hideLabel,
    }]),
    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.input.$el ? _ctx.input.$el.focus() : false))
  }, [
    (_ctx.iconLeft)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, [
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.iconLeft)
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("label", {
          for: _ctx.component.id,
          innerHTML: _ctx.label
        }, null, 8, _hoisted_4),
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component.currentComponent), {
          value: _ctx.value,
          id: _ctx.component.id,
          readonly: _ctx.readonly,
          disabled: _ctx.disabled,
          "min-date": _ctx.minDate,
          "max-date": _ctx.maxDate,
          ref: "input",
          "disable-weekend": _ctx.disableWeekend,
          autocomplete: _ctx.autocomplete,
          onKeypress: _cache[0] || (_cache[0] = ($event: any) => (_ctx.component.error = [])),
          onInput: _ctx.onInput,
          onBlur: _ctx.onBlur,
          onFocusin: _cache[1] || (_cache[1] = ($event: any) => (_ctx.focused = true)),
          onFocusout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.focused = false)),
          onPaste: _ctx.onPaste,
          onDrop: _ctx.onPaste
        }, null, 8, ["value", "id", "readonly", "disabled", "min-date", "max-date", "disable-weekend", "autocomplete", "onInput", "onBlur", "onPaste", "onDrop"])),
        (_ctx.hasError)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "input-field__error-message fs-small",
              innerHTML: _ctx.errorMessage
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ])
    ]),
    ((!_ctx.showLoader && !_ctx.hasError && _ctx.showValidCheck) || _ctx.showLoader || _ctx.iconRight || _ctx.type === 'date')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, [
            (!_ctx.showLoader && !_ctx.hasError && _ctx.showValidCheck)
              ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                  key: 0,
                  icon: "fa-light fa-check"
                }))
              : (_ctx.showLoader)
                ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                    key: 1,
                    icon: "fa-light fa-spinner",
                    class: "fa-pulse"
                  }))
                : (_ctx.type === 'date')
                  ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                      key: 2,
                      icon: "fa-light fa-calendar-alt"
                    }))
                  : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}